<template>
  <div v-if="!show" class="ui active loader"></div>

  <div v-if="show" id="contain" class="ui center aligned padding grid">
    <div class="ui row info">
      <div class="ui field" id='paquetesTotales'>
        <img class="ui image" id="imgPackage" src="../assets/package2.png">
        Paquetes a recoger: <b>{{total_shipments}}</b>
      </div>

      <div class="ui field">
        <form class="ui large form" @submit.prevent="receive_shipment">
          <button id="idBtnRecoger" class="ui fluid large teal button recoger" type="submit">Recoger paquete</button>
        </form>
      </div>

      <div class="ui field">
        <form class="ui large form" @submit.prevent="cancelarRecogida">
          <button id="idBtnCancelar" class="ui fluid large teal button cancelar" type="submit">Cancelar operación</button>
        </form>
      </div>

      <div class="ui row iconoMsgInfo">
        <div class="ui content mensaje">
          <div class="ui field icono">
            <i class="info circle icon"></i>
          </div>
          <div class="ui field msgInfo">
            Para recoger los envíos pulsa RECOGER PAQUETE.<br><br>
            Si tienes más de un envío, se abrirán los cajones de uno en uno.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PickUpPackages',
  props: ['apm','code'],
   data() {
    return {
      total_shipments: 0,
      delivered: 0,
      inapt: 0,
      msg: null,
      type: null,
      title: null,
      codError: null,
      closeSession: 1,
      show: false,
      error_receive: null,
      totalIntentos: 1,
    }
  },
  created() {
    this.validate_code();
  },
  methods: {
    validate_code() {

      let url = this.$url_hapiick + '/v1/validations/code';
      let headers = {
        'Content-Type': 'application/json',
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.post(url, {
        apm: this.apm,
        code: this.code
      },{
        headers: headers
      })
      .then(request => {      
        this.codError = request.data.error
        this.total_shipments = request.data.n_shipments
        this.token = request.data.token

        if (this.codError) {
          this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
        } else {
          if (!this.token) { //token caducado, ponemos codigo 401
            this.redirect(401,this.title,'','',this.token,this.closeSession);
          } else {
            if (this.total_shipments > 0) {
              this.show = true;
            } else {
              this.msg = 'No hay paquetes pendientes por recoger.';
              this.type = 'info';
              this.redirect('',this.title,this.msg,this.type,this.token,this.closeSession);
            }
          }
        }
      })
     .catch(error => {
        this.catchErrors(error);
      })
    },
    receive_shipment() {
      document.getElementById('idBtnRecoger').disabled=true;
      document.getElementById('idBtnCancelar').disabled=true;

      let url = this.$url_hapiick + '/v1/shipments/receive';
      let headers = {
        'Content-Type': 'application/json',
        'X-Auth-Token': this.token,
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.post(url, {
        apm: this.apm,
      },{
        headers: headers
      })
      .then(request => {
        this.codError = request.data.error
        this.delivered = request.data.shipments.delivered
        this.total_shipments = request.data.shipments.inapt

        if (request.data.shipments.provider_error) {
          if (request.data.shipments.provider_error.message) {
            this.error_receive = request.data.shipments.provider_error.message
          }
        }

        if (this.codError) {
          this.msg = '';
          this.type = '';
          this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
        } else {
            if (this.delivered == 0) {
              if (this.error_receive === 'opened_slot') {
                this.$swal({
                  icon: 'info',
                  text: 'Para poder recoger el siguiente envió, por favor, asegurate de haber cerrado el cajon.',
                })
                document.getElementById('idBtnRecoger').disabled = false;
                document.getElementById('idBtnCancelar').disabled = false;
              //} else if (this.error_receive === 'application_exception') {

              } else {
                if (this.totalIntentos < 2) {
                  this.totalIntentos++;
                  this.$swal({
                    icon: 'error',
                    text: 'Ha habido un problema. Por favor, vuelve a intentarlo.',
                  })
                  document.getElementById('idBtnRecoger').disabled = false;
                  document.getElementById('idBtnCancelar').disabled = false;
                } else {
                  this.codError = '';
                  this.type = 'error';
                  this.title = 'OPERACIÓN CANCELADA.';
                  this.msg = 'Ponte en contacto a través del teléfono 934 177 199. Disculpa las molestias. Gracias.';
                  this.redirect(this.codError,this.title,this.msg,this.type,this.token,this.closeSession);
                }
              }
            } else {
              this.$swal({
                text: '¿Has recogido correctamente el paquete?',
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No'
              }).then((result) => {
                if (result.isConfirmed) {
                  if (this.total_shipments > 0) {
                    document.getElementById('idBtnRecoger').disabled = false;
                    document.getElementById('idBtnCancelar').disabled = false;
                  } else {
                    this.codError = '';
                    this.title = 'paquetes_recogidos_OK'
                    this.msg = 'Y acuérdate de CERRAR el CAJÓN después. GRACIAS.';
                    this.type = 'info';
                    this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
                  }
                } else {
                  this.codError = '';
                  this.title = 'paquetes_recogidos_KO'
                  this.msg = 'Ponte en contacto a través del teléfono 943 177 199. Disculpa las molestias. GRACIAS.';
                  this.type = 'info';
                  this.redirect(this.codError,this.title,this.msg,this.type,this.token,this.closeSession);
                }
              })
            }
        }
      })
      .catch(error => {
        this.catchErrors(error);
      })
    },
    catchErrors(error){
      if(error.request) {
        if (error.request.status == 429) {
          this.codError = error.request.status
          this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
        } else {
          console.log(error.request)
        }
      }
    },
    cancelarRecogida() {
      this.codError = '';
      this.msg = 'Operación cancelada por el usuario.';
      this.type = 'success';
      this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
    },
    redirect(codError, title, msg, type, token, closeSession) {
      this.$router.push({name: 'Messages',params: {codError: codError, title: title, msg: msg, type:type, token:token, closeSession:closeSession}});
    },
  }
}
</script>

<style scoped>
a {
  color: darkslategrey;
}

b {
  font-size: 25px;
}

button {
  height: 55px;
}

button .field {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: row;
  flex-direction: row;
  margin-top: 10px;
}

#contain {
  margin: auto!important;
  width: 90%;
  left: 5%;
  height: 85%;
  position: absolute;
  top: 10%;
  overflow: auto;
  padding-top: 0.5em!important;
  align-items: center;
}

#paquetesTotales {
  padding-bottom: 15px;
}

#imgPackage {
  width: 65px;
  margin: auto!important;
}

.row.info {
  width: 100%;
  height: 100%;
}

.field > form {
  margin: 20px 0px 30px 0px;
}

.ui.header {
  font-family: 'Helvetica Neue',Arial,Helvetica,sans-serif;
}

.content {
  font-size: 18px!important;
}

.recoger {
  color: black !important;
  background-color: #00f9a9 !important;
}

.cancelar {
  color: white !important;
  background-color: black !important;
}

.mensaje {
  display: flex;
  padding-top: 10px;
}

.iconoMsgInfo {
 padding-top: 30px;
}

.icono {
  width:20%;
}

.icono i {
  font-size: 45px;
  width: 100%;
}

.msgInfo{
  width: 80%;
  font-size: 14px!important;
}

.icono, .msgInfo {
  height: 80px;
  text-align: justify!important;
  display:flex;
  align-items: center;
  color: black;
}

.ui.grid>.row {
  display: unset!important;
  padding: 0px!important;
}

@media screen and (max-width: 768px) and (min-height: 200px) and (max-height: 649px){   
  #contain {
    padding-top: 10px!important;
  }

  .iconoMsgInfo {
    padding-top: 15px!important;
  }
}

@media screen and (max-width: 768px) and (min-height: 650px) and (max-height: 800px) {   
  #contain {
    padding-top: 60px!important;
  }

  .iconoMsgInfo {
    padding-top: 35px!important;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px){   
  #contain {
    padding-top: 20px!important;
  }

  .iconoMsgInfo {
    padding-top: 0px!important;
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px){   
  #contain {
    padding-top: 30px!important;
  }


  .iconoMsgInfo {
    padding-top: 20px!important;
  }
}

@media screen and (min-width: 1200px){   
  #contain {
    padding-top: 30px!important;
  }

  .iconoMsgInfo {
    padding-top: 20px!important;
  }
}
</style>
